"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flagged;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
function specifiedOffices(state, offices) {
  var {
    config: {
      env: {
        nodeEnv
      },
      organisationIds = []
    }
  } = state;

  // Always on for development unless offices specified
  if (nodeEnv === 'development' && !offices.length) return true;

  // Otherwise check if enabled for any of the matching offices
  return (0, _reduce.default)(offices).call(offices, (result, id) => {
    if (result) return result; // If any match, true

    return (0, _indexOf.default)(organisationIds).call(organisationIds, id) !== -1;
  }, false);
}
var servicePages = state => specifiedOffices(state, state.config.env.servicePageOffices || []);
var handlers = {
  servicePages
};
function flagged(name, state) {
  return handlers[name] ? handlers[name](state) : false;
}